const CompatConditionalPricing = {
	init: function () { 
		if ( 'undefined' === typeof GWConditionalPricing ) {
			return;
		}

		if ( 'undefined' !== typeof pagenow && pagenow === 'toplevel_page_gf_edit_forms' && jQuery( '#tab_conditional_pricing_page' ).length ) { 
			CompatConditionalPricing.updateGlobalCurrency()
		}

		if ( ! jQuery( '.gfield--type-multicurrency' ).length ) {
			return;
		}

		// Run this before mcg.filter_gform_get_base_price. Pass the conditional price.
		gform.addFilter( 'mcg_get_product_price_flattened', CompatConditionalPricing.updateBasePrice, 5 );

		/**
		 * Convert the prices before its saved by Conditional Pricing.
		 *
		 * args = {gwcp, formId, input,inputId,isReset, productId}
		 */
		gform.addFilter( 'gpcp_price', function ( origPrice, args ) {
			var new_amt = _mcg.flatToCurrentCurrency( origPrice * 100, args.formId, true );	

			// Update value of the duplicate price span created by us. 
			var currency = new Currency( gf_global[ 'gf_currency_config' ] );
			var new_amt_formatted = currency.toMoney( new_amt );
			jQuery( args.input[ 0 ] ).closest( '.ginput_product_price_wrapper' ).find( '.ginput_product_price' ).text( new_amt_formatted );

			return new_amt;
		} );

		gform.addFilter( 'mcg_calculation_skip_update_price', CompatConditionalPricing.skipUpdatePrice, 10 );
	},

	skipUpdatePrice: function ( skip ) {
		// Prevent possible loop by saving the execution time and then returning true if
		// the function is called again within 50 ms.
		window.gwcp_price_last_execution = window.gwcp_price_last_execution || 0;

		// console.log('diff', Date.now() - window.gwcp_price_last_execution );
		if ( Date.now() - window.gwcp_price_last_execution < 100 ) {
			return true;
		}

		if ( !jQuery( '.gfield--input-type-calculation' ).length ) {
			return true;
		}

		window.gwcp_price_last_execution = Date.now();
	},

	/**
	 * Change the base price of the product field based on the conditional pricing.
	 *
	 * Code inspired from updatePricing() function of Conditional Pricing
	 * (gwconditionalpricing/scripts/gwconditionalpricing.js)
	 * 
	 * @param {*} fieldId 
	 * @param {*} productId 
	 *
	 * @returns float|false
	 */
	getConditionalPrice: function ( formId, productFieldId ) {
		if ( ! GWConditionalPricing || ! GWConditionalPricing.getFormElement ) {
			return false;
		}

		let gfcp = GWConditionalPricing.getFormElement( formId ).data( 'gwcp' );
		let price = false;

		if ( ! gfcp || ! gfcp._pricingLogic || ! productFieldId ) {
			return price;
		}

		for ( var productId in gfcp._pricingLogic ) {
			// only run for one product.
			if ( productId !== productFieldId ) {
				continue;
			}

			if ( !gfcp._pricingLogic.hasOwnProperty( productId ) ) {
				continue;
			}

			var pricingLevels = gfcp._pricingLogic[ productId ];

			// This can happen if they delete a product from the form without removing the conditional pricing rules.
			if ( !pricingLevels || pricingLevels[ 0 ] === null ) {
				continue;
			}

			for ( var i = 0; i < pricingLevels.length; i++ ) {

				var pricingLevel = pricingLevels[ i ],
					isMatch = gfcp.isMatch( gfcp._formId, pricingLevel.conditionalLogic );

				if ( !isMatch ) {
					continue;
				}

				return pricingLevel.price;
			}

			// if no matching pricing level was found, set back to basePrice.
			return price;
		}
	},

	/**
	 * Change the base price of the product field based on the conditional pricing.
	 *
	 * Code inspired from updatePricing() function of Conditional Pricing
	 * (gwconditionalpricing/scripts/gwconditionalpricing.js)
	 *
	 * @param {*} price 
	 * @param {*} $product_field 
	 * @returns 
	 */
	updateBasePrice: function( price, $product_field ) {
		var formId = _mcg.get_form_id( $product_field );
		var productFieldId = gf_get_input_id_by_html_id( $product_field.attr( 'id' ) );

		if ( $product_field.hasClass( 'gfield--type-choice' ) ) {
			var $checked = $product_field.find( 'input:checked' );
			if ( $checked && $checked.length ) {
				productFieldId = gf_get_input_id_by_html_id( $product_field.find( 'input:checked' ).attr( 'id' ) );
				productFieldId = CompatConditionalPricing.versionBump( productFieldId ); // example - if field ID is 3.0, then make it 3.1
			}
		}

		var conditionalPrice = CompatConditionalPricing.getConditionalPrice( formId, productFieldId );
		if ( ! conditionalPrice ) {
			return price;
		}

		// if a matching pricing level was found, set the price to the new price after currency conversion
		return conditionalPrice * 100;
	},

	/**
	 * Increase the value of minor version (sub-field)
	 * Example if field id is 3.1, then this function changes it to 3.2.
	 * 
	 * This is needed because there is a difference of one decimal between
	 * Conditional pricing rule and Gravity Forms field ID.
	 *
	 * @param {string} version 
	 * @returns 
	 */
	versionBump: function( version ) {
		const parts = version.split('.');
		if (parts.length !== 2) {
		  return version;
		}
	  
		try {
		  const major = parseInt(parts[0], 10);
		  const minor = parseInt(parts[1], 10) + 1;
		  return `${major}.${minor}`;
		} catch (error) {
		  return version
		}
	},

	/**
	 * Update global currency.
	 */
	updateGlobalCurrency: function () {
		gf_global.gf_currency_config = idea_mcg.all_currencies[ mcg_cp_data.base_currency ];
	}

}

export default CompatConditionalPricing;